import React from "react";
import "./WhyChoose.css";

/*
  Material Icons Outlined - make sure it's loaded in your index.html
  Add this to public/index.html in the <head>:
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined" rel="stylesheet" />
*/

const items = [
  {
    title: "Strengthening Families & Communities",
    desc: "Partnering with Community Impact Solutions LLC means strengthening families by intentionally engaging fathers and building programs that create lasting community impact. We combine extensive experience in fatherhood engagement, family-centered program design, and nonprofit development to help organizations deliver practical, culturally responsive, and results-driven services.",
  },
  {
    title: "Fatherhood Programming & Support",
    desc: "Our fatherhood programming equips dads with the tools, support, and skills to stay actively involved in their children's lives while strengthening co-parenting, stability, and connection. In addition, we support organizations with strategy, training, and capacity building to ensure their programs are inclusive, sustainable, and effective.",
  },
  {
    title: "A Dedicated Ally",
    desc: "When partnering with us, not only do you gain a consultant, but you gain an ally committed to strengthening families and expanding your organization's impact. Through expertise in fatherhood engagement, family-centered programming, and nonprofit development, we help build culturally responsive, sustainable services that support fathers, strengthen co-parenting, and create lasting community change.",
  },
];

const WhyChoose = () => {
  return (
    <section className="why-choose" id="why-choose" aria-label="Why choose us">
      <div className="why-choose__container">
        {/* Header with title only */}
        <div className="why-choose__header">
          <h2 className="why-choose__title">
            Why Partner With <span>Community Impact Solutions</span>
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="why-choose__grid">
          {items.map((item, idx) => (
            <article className="why-choose__card" key={idx}>
              <h3 className="why-choose__cardTitle">{item.title}</h3>
              <p className="why-choose__cardDesc">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;